import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  GetUserPreferencesRequest,
  GetUserPreferencesResponse,
  UpdateUserPreferencesRequest,
  UpdateUserPreferencesResponse,
} from 'src/types/orbit/UserPreferences';

export const userPreferencesService = {
  get: (data: GetUserPreferencesRequest) => {
    return apiClient.get<GetUserPreferencesResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.PREFERENCES.GET(data.programId, data.userId),
      ),
      data,
    );
  },

  update: (data: UpdateUserPreferencesRequest) => {
    return apiClient.put<UpdateUserPreferencesResponse, UpdateUserPreferencesRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.PREFERENCES.UPDATE(data.programId, data.userId),
      ),
      data,
    );
  },
};
